const CUSTOM_ICONS = ['hotness', 'galaxy-ai-icon-monochrome'];

export function isCustomIcon(iconName: string): boolean {
  return !!CUSTOM_ICONS.find((icon) => icon === iconName);
}
